/**
 * Base class for connection routers.
 */
class ConnectionRouterBase {
    constructor() { }
}

export { ConnectionRouterBase };
